<template>
  <el-dialog
    append-to-body
    center
    fullscreen
    :show-close="false"
    title="dHome创作者平台原创声明"
    :visible="true"
  >
    <div class="declare">
      <p>
        本人承诺所提供的内容系本人自身创作形成的原创内容。本人,作为dHome用户,兹此同意基于本人原创內容做出独立完成创作之作品的声明,并进一步
        同意本人原创内容可以经编辑审核,通过审核的优质原创内容在dHome平台得以推荐和发表。
        本人同意并确认,以下内容不得发布或声明为原创内容
      </p>
      <div class="list">
        <p>1.存在著作权法第四十七条、第四十八条行为之一形成的作品;</p>
        <p>
          2.任何抄袭或者模仿任何第三方(包括但不限于其他用户、第三方平台、非本人的其他个人等)作品
        </p>
        <p>
          3.没有在未取得相关权利人合法授权或许可之情况下,使用他人著作权进行创作(包括但不限于图片、文章等);
        </p>
        <p>4.提供的作品存在权属争议、权利限制或瑕疵、设置抵押、质押或担保;</p>
        <p>5.违反中华人民共和国法律、法规、政策或不符合社会良好风尚;</p>
        <p>6.其他dHome认为不适宜公开发布的内容。</p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.declare {
  width: 960px;
  margin: 0 auto;
  .list {
    margin-top: 20px;
    line-height: 28px;
  }
}
</style>